import { PencilLine } from "lucide-react";

const InlineEditableField = ({
  label,
  value,
  title,
  isEditing,
  onEdit,
  children,
}) => {
  const canEdit = typeof onEdit === "function";

  return (
    <div title={title} className="group grid grid-cols-[100px_1fr] gap-2 items-center text-xs">
      {/* Label */}
      <span className="text-gray-500 whitespace-nowrap">{label}</span>

      {/* Value / Editor */}
      <div className="flex items-center gap-2 min-w-0">
        {isEditing ? (
          children
        ) : (
          <>
            <span className="font-medium text-gray-800 truncate">
              :&nbsp; {value || "-"}
            </span>

            {canEdit && (
              <button
                onClick={onEdit}
                className="opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <PencilLine className="w-3.5 h-3.5 text-gray-500 hover:text-[#004645]" />
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InlineEditableField;
